





























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import FileUpload from './FileUpload.vue'
import { FILE_UPLOAD_URL, delContractFile } from '@/service/step-five'

interface ResponseFile {
  id: number;
  file_name: string;
  file_url: string;
  is_img: 0 | 1; // 是否为图片1：是，0：否
  contract_type: 0 | 1; // 类型 0:协议资质 1:非标合同
}

function transformFile(file: ResponseFile) {
  return {
    uid: file.id,
    url: file.file_url,
    name: file.file_name,
    $type: file.is_img ? 'image' : file.file_name.endsWith('pdf') ? 'pdf' : 'file'
  }
}

@Component({ components: { FileUpload } })
export default class ExtraInfo extends Vue {
  @Prop({ required: true }) files!: ResponseFile[]
  uploadUrl = FILE_UPLOAD_URL
  accept = 'image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  qualificationFiles: any = []
  contractFiles: any = []

  @Watch('files', { immediate: true })
  setFiles(list: ResponseFile[]) {
    list.forEach(file => {
      file.contract_type
        ? this.contractFiles.push(transformFile(file))
        : this.qualificationFiles.push(transformFile(file))
    })
  }

  handleDelete(file: any) {
    return delContractFile(file.uid)
  }
}
